export default __webpack_public_path__ + "static/media/superstylin.aab1d73c.png";